import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import stylesContent from "./MainMenu.module.css";
import Home from "../../shared/pages/home/Home";
import DisabledHome from "../../shared/pages/home/DisabledHome";
import Login from "../../shared/pages/login/Login";
import Register from "../../shared/pages/register/Register";
import NewPassword from "../../shared/pages/newPassword/NewPassword";
import ForgetPassword from "../../shared/pages/forgetPassword/ForgetPassword";
import ForgotPasswordPhone from "../../shared/pages/forgetPassword/ForgotPasswordPhone";
import ForgotPasswordOTPVerification from "../../shared/pages/forgetPassword/ForgotPasswordOTPVerification";
import ListData from "../../pages/taxDeclaration/listData/ListData";
import ListDisputeData from "../../pages/taxDispute/listData/ListDisputeData";
import ListAppealData from "../../pages/taxAppeal/listData/ListAppealData";
import DeclarationListData from "../../pages/UnifiedTaxDeclaration/listData/index";
import MyDebts from "../../pages/UnifiedTaxDeclaration/myDebts";
// import AddNewTaxDeclaration from "../../pages/taxDeclaration/addNewTaxDeclaration/AddNewTaxDeclaration";
// import { TaxDeclartionProvider } from "../../contexts/TaxDeclaration";
// import MessageConfirmation from "../../pages/taxDeclaration/messageConfirmation/MessageConfirmation";
import MessageConfirmationDispute from "../../pages/taxDispute/messageConfirmation/MessageConfirmation";
import Profile from "../../shared/pages/profile/Profile";
import UserProfile from "../../shared/pages/userProfile/userProfile";
import UserSettings from "../../shared/pages/profile/UserSettings";
import UserTransactionAccount from "../../shared/pages/UserTransactionAccount/UserTransactionAccount";
import SetPassword from "../../shared/pages/setPassword/SetPassword";
import CommingSoon from "../../shared/pages/commingSoon/CommingSoon";
import NoConnection from "../../shared/pages/noConnection/NoConnection";
import Details from "../../pages/taxDeclaration/details/Details";
import NotFound from "../../shared/pages/notFound/NotFound";
import RequireAuth from "../../components/auth/RequireAuth";
import RequireVerified from "../../components/auth/RequireVerified";
import Verify from "../../shared/pages/verfiy/Verfiy";
import RequireNotAuth from "../../components/auth/RequireNotAuth";
import ElectronicPaymentConfirm from "../../pages/electronicPayment/ElectronicPaymentConfirm";
import ListOnlinePayment from "../../pages/electronicPayment/ListOnlinePayment";
import AddNewElectronicPayment from "../../pages/electronicPayment/AddNewElectronicPayment";
import DetailsOnlinePayment from "../../pages/electronicPayment/DetailsOlinePayment";
import RequestDetails from "../../pages/taxDispute/Details";
import AppealRequestDetails from "../../pages/taxAppeal/Details";
import UnifiedTaxDeclarationDetails from "../../pages/UnifiedTaxDeclaration/Details";

import AppealPayment from "../../pages/taxAppeal/TaxAppealPayment";

import PayOnline from "../../pages/electronicPayment/PayOnline";
import PDFReceipt from "../../pages/electronicPayment/PDFReceipt";
import TaxDisputePdfReceipt from "../../pages/taxDispute/TaxDisputePdfReceipt";

import Support from "../../pages/support/Support";
import TermsAndCondition from "../../pages/support/TermsAndCondition";
import AddNewTaxDispute from "../../pages/taxDispute/addNewTaxDispute/AddNewTaxDispute";
import AddNewTaxAppeal from "../../pages/taxAppeal/addNewTaxAppeal/AddNewTaxAppeal";
import AddUnifiedTaxDeclaration from "../../pages/UnifiedTaxDeclaration/AddUnifiedTaxDeclaration/AddUnifiedTaxDeclaration";
import UnifiedTaxDeclarationSubmissionGuide from "../../pages/UnifiedTaxDeclaration/SubmissionGuide";
import { TaxAppealProvider } from "../../contexts/TaxAppealProvider";
import { UnifiedTaxDeclarationProvider } from "../../contexts/UnifiedTaxDeclarationProvider";

import ConfirmOtp from "../../shared/pages/confirmOtp/confirmOtp";
import PaymentUnderAccountList from "../../pages/UnifiedTaxDeclaration/paymentUnderAccountDebt";
import ClaimPayments from "../../pages/UnifiedTaxDeclaration/claimPayments";
import PaymentAccountDebtList from "../../pages/UnifiedTaxDeclaration/settlementPaymenAccountDebtTaxpayerBehalf";
import CreatePropertyPaymentRequest from "../../pages/UnifiedTaxDeclaration/createPropertyPaymentRequest";
import UnifiedTaxDeclarationRecievePayment from "../../pages/UnifiedTaxDeclaration/UnifiedTaxDeclarationPayment";
import NotificationList from "../../shared/pages/NotificationList";
import NotificationDetails from "../../shared/pages/NotificationDetails";
import ConfirmOtpForget from "../../shared/pages/confirmOtp/confirmOtpForget";
import MailVerfiy from "../../shared/pages/mailVerify/mailVerify";
import MailVerifyForget from "../../shared/pages/mailVerify/mailVerifyForget";
import CheckResetPassValidty from "../../shared/pages/newPassword/CheckResetPassValidty";
import MailVerifyProfile from "../../shared/pages/mailVerify/MailVerifyProfile";
import ConfirmOtpProfileVerification from "../../shared/pages/confirmOtp/ConfirmOtpProfileVerification";
import VerfiyMailProfile from "../../shared/pages/verfiy/VerfiyMailProfile";
import CommonAddressMap from "../../shared/pages/map/CommonAddressMap";
import IframeMapComponent from "../../shared/pages/map/IframeMapComponent";
import MapComponent from "../../shared/pages/map/Map";
import HelpAndInstructions from "../../shared/pages/helpAndInstructions/HelpAndInstructions";

function MainMenu(props) {
  return (
    <div className={stylesContent.content}>
      <Routes>
        {/* Public Routes */}
        <Route path="/no-connection" element={<NoConnection />} />
        <Route path="*" element={<NotFound />} />
        <Route exact path="/" element={<Home />} />
        {/* <Route path="/DisabledHome" element={<DisabledHome />} /> */}
        <Route path="/terms-and-condition" element={<TermsAndCondition />} />
        <Route exact path="/iframe-map" element={<IframeMapComponent />} />
        {/* <Route exact path="/iframe-map2" element={<IframeMapComponentTwo />} /> */}

        {/** Required Not Auth */}
        <Route element={<RequireNotAuth />}>
          {/* TODO  */}
          <Route exact path="/map" element={<MapComponent />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route
            path="/forget-password-phone"
            element={<ForgotPasswordPhone />}
          />
          <Route
            path="/forget-password-otp-verification"
            element={<ForgotPasswordOTPVerification />}
          />
          <Route path="/new-password" element={<NewPassword />} />
          <Route path="/confirm-otp" element={<ConfirmOtp />} />
          <Route path="/confirm-otp-forget" element={<ConfirmOtpForget />} />
          <Route path="/mail-verified" element={<MailVerifyForget />} />
          <Route path="/mail-verify" element={<MailVerfiy />} />
          <Route
            path="/check-reset-password-validity"
            element={<CheckResetPassValidty />}
          />
        </Route>

        <Route path="/auth/email/verify" element={<Verify />} />

        <Route element={<RequireAuth />}>
          <Route exact path="/" element={<Home />} />
          <Route
            path="/user-transactions"
            element={<UserTransactionAccount />}
          />

          <Route path="/home" element={<Home />} />

          <Route
            path="/tax-dispute-request/details/:id"
            element={<RequestDetails />}
          />
          <Route element={<UnifiedTaxDeclarationProvider />}>
            {/* <Route
              exact
              path="/iframe-map/:mapType"
              element={<IframeMapComponent />}
            /> */}
            <Route
              exact
              path="/common-map/:new_urban_communities_authority/:hasContainer"
              element={<CommonAddressMap />}
            />

            <Route
              path="/tax-declaration/add"
              element={<AddUnifiedTaxDeclaration />}
            />
            <Route
              path="/tax-declaration/submission-guide"
              element={<UnifiedTaxDeclarationSubmissionGuide />}
            />
            <Route
              path="/tax-declaration/update/:id"
              element={<AddUnifiedTaxDeclaration />}
            />
            <Route
              path="/tax-declaration/details/:id"
              element={<AddUnifiedTaxDeclaration />}
            />
            <Route
              path="/tax-declaration/list-data"
              element={<DeclarationListData />}
            />

            <Route
              path="/tax-declaration/payment-under-account/list/:id"
              element={<PaymentUnderAccountList />}
            />

            <Route
              path="/payment-account-debt/list/:id"
              element={<PaymentAccountDebtList />}
            />

            <Route
              path="/payment-transactions/list/:id/:declerationId/:typeId"
              element={<ClaimPayments />}
            />

            <Route
              path="/payment-transactions/list/my-debts/:id"
              element={<ClaimPayments />}
            />

            {/* <Route
              path="/tax-declaration/settlement-account-debt"
              element={<DeclarationListData />}
            /> */}

            <Route
              path="/tax-declaration/details/:id"
              element={<UnifiedTaxDeclarationDetails />}
            />
            <Route
              path="/tax-declaration/payment/:id"
              element={<UnifiedTaxDeclarationRecievePayment />}
            />
            <Route
              path="/tax-declaration/payment-under-account/list/:id"
              element={<PaymentUnderAccountList />}
            />
            <Route
              path="/payment-account-debt/list/:id"
              element={<PaymentAccountDebtList />}
            />
            {/* <Route
              path="/payment-transactions/list/:id"
              element={<ClaimPayments />}
            /> */}
            <Route
              path="/settlement-account-debt"
              element={<DeclarationListData />}
            />
            <Route path="/my-debts" element={<MyDebts />} />
            <Route
              path="/my-debts/create-payment-request"
              element={<CreatePropertyPaymentRequest />}
            />
            <Route
              path="/my-debts/create-payment-request/:id"
              element={<CreatePropertyPaymentRequest />}
            />
            <Route
              path="/tax-declaration/details/:id"
              element={<UnifiedTaxDeclarationDetails />}
            />
          </Route>
          <Route element={<TaxAppealProvider />}>
            <Route path="/tax-appeal/add" element={<AddNewTaxAppeal />} />
            <Route path="/tax-appeal/list-data" element={<ListAppealData />} />
            <Route
              path="/tax-appeal/temporary"
              element={<AppealRequestDetails />}
            />
            <Route
              path="/tax-appeal/details/:id"
              element={<AppealRequestDetails />}
            />
            <Route path="/tax-appeal/payment/:id" element={<AppealPayment />} />
          </Route>
          <Route
            path="/tax-dispute-request/list-data"
            element={<ListDisputeData />}
          />
          {/* <Route
              path="/tax-declaration/message-confirmation"
              element={<MessageConfirmation />}
            /> */}
          <Route
            path="/online-payment/list-payment"
            element={<ListOnlinePayment />}
          />
          <Route
            path="/online-payment/details/:id"
            element={<DetailsOnlinePayment />}
          />
          <Route
            path="/payment/details/:id"
            element={<DetailsOnlinePayment />}
          />
          <Route
            path="/online-payment/pdf-Receipt/:id"
            element={<PDFReceipt />}
          />
          {/* tax dispute pdf */}
          <Route
            path="/tax-dispute/request-print-pdf/:id"
            element={<TaxDisputePdfReceipt />}
          />
          <Route
            path="/online-payment/pay-online/:id"
            element={<PayOnline />}
          />
          <Route
            path="/online-payment/new-payment"
            element={<AddNewElectronicPayment />}
          />
          {/* <Route
              path="/online-payment/confirm/:id"
              element={
                <TaxDeclartionProvider>
                  <ElectronicPaymentConfirm />
                </TaxDeclartionProvider>
              }
            /> */}
          {/* <Route
              path="/tax-declaration/add"
              element={
                <TaxDeclartionProvider>
                  <AddNewTaxDeclaration />
                </TaxDeclartionProvider>
              }
            />
            <Route
              path="/tax-declaration/details/:id"
              element={
                <TaxDeclartionProvider>
                  <Details />
                </TaxDeclartionProvider>
              }
            />
            <Route
              path="/tax-declaration/update/:id"
              element={
                <TaxDeclartionProvider>
                  <UpdateTaxDeclaration />
                </TaxDeclartionProvider>
              }
            /> */}
          <Route path="/tax-dispute/add" element={<AddNewTaxDispute />} />

          <Route
            path="/tax-dispute/message-confirmation"
            element={<MessageConfirmationDispute />}
          />

          <Route path="/DisabledHome" element={<DisabledHome />} />
          {/* <Route
            path="/auth/profile-email/verify"
            element={<VerfiyMailProfile />}
          /> */}
          <Route
            path="/confirm-otp-profile-verification"
            element={<ConfirmOtpProfileVerification />}
          />
          <Route path="/mail-verify-profile" element={<MailVerifyProfile />} />

          <Route path="/confirm-otp" element={<ConfirmOtp />} />
          <Route path="/confirm-otp-forget" element={<ConfirmOtpForget />} />
          <Route path="/mail-verified" element={<MailVerifyForget />} />
          <Route path="/mail-verify" element={<MailVerfiy />} />
          <Route path="/user-settings" element={<UserSettings />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/notification/list" element={<NotificationList />} />
          <Route
            path="/notification/details/:id"
            element={<NotificationDetails />}
          />
          <Route path="/support" element={<Support />} />
          <Route path="/terms-and-condition" element={<TermsAndCondition />} />
          <Route path="/coming-soon" element={<CommingSoon />} />
          <Route
            path="/help-and-instructions"
            element={<HelpAndInstructions />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default MainMenu;
